import script from "./RecipeForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecipeForm.vue?vue&type=script&setup=true&lang=ts"

import "./RecipeForm.vue?vue&type=style&index=0&id=777b5e80&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-777b5e80"]])

export default __exports__